import React from 'react';
import './LegendSingle.css';
import { PageTitle } from '../../../components';
import { FaCalendarAlt, FaUsers, FaClock } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { legends } from '../../../constants';

const LegendSingle = () => {
    const { id } = useParams();
    const legend = legends.find((item) => item.id.toString() === id);

    if (!legend) {
        return (
            <div className="container" style={{ padding: '100px 0', textAlign: 'center' }}>
                <h2>Nie znaleziono legendy.</h2>
            </div>
        );
    }

    return (
        <>
            {/* Page title - Now using 'legend' (single) instead of 'legends' (array) */}
            <PageTitle title={legend.title} page={'Legenda'} />

            <section className='legend-single'>
                <div className='legend-intro'>


                    <div className='information'>
                        <h3>{legend.title}</h3>
                        <h5>{legend.subtitle}</h5>

                        <div className='legend-about'>
                            <div className='text' style={{ whiteSpace: 'pre-line' }}>
                                {legend.content}
                            </div>
                        </div>

                        {/* Meta Info */}
                        <ul className="legend-meta-info">
                            <li>
                                <h6><FaCalendarAlt className='icon' /> Data:</h6>
                                <span>{legend.date}</span>
                            </li>
                            <li>
                                <h6><FaUsers className='icon' /> Autor:</h6>
                                <span>{legend.author}</span>
                            </li>
                            <li>
                                <h6><FaClock className='icon' /> Czas czytania:</h6>
                                <span>{legend.readTime}</span>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>
        </>
    );
}

export default LegendSingle;